import React from "react";
import styled from "styled-components";
import { Trans, withTranslation } from "react-i18next";
import { Alert, Col, Row } from "components/bootstrap";
import { Icon } from "components/common";
import { MetricsList } from "components/metrics";
import SearchForm from "components/common/SearchForm";
const StyledWarningDiv = styled.div(
  ({ theme }) => `
  height: 20px;
  margin-bottom: 5px;
  color: ${theme.colors.variant.dark.danger};
`
);
const safelyFilterNames = (filter, names) => {
  try {
    const filterRegex = new RegExp(filter, "i");
    return names.filter((metric) => String(metric.full_name).match(filterRegex));
  } catch (_e) {
    return [];
  }
};
const MetricsListContainer = styled.div`
  padding-top: 10px;
  width: 100%;
`;
class MetricsComponent extends React.Component {
  constructor(props) {
    super(props);
    this.onFilterChange = (nextFilter) => {
      this.setState({ filter: nextFilter });
    };
    this.state = { filter: props.filter };
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.filter !== this.props.filter) {
      this.setState({ filter: nextProps.filter });
    }
  }
  render() {
    const { filter } = this.state;
    const { names, error, t } = this.props;
    if (!names) {
      return /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger" }, error ? /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(
        Trans,
        {
          t,
          i18nKey: "metrics_component.fetch_error",
          values: { responseMessage: error.responseMessage || "", status: error.status },
          components: { em: /* @__PURE__ */ React.createElement("em", null) }
        }
      )) : /* @__PURE__ */ React.createElement("span", null, t("metrics_component.fetch_problem")), " ", t("metrics_component.retry_in_background"))));
    }
    const filteredNames = safelyFilterNames(filter, names);
    return /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(StyledWarningDiv, { className: "text-warning" }, error && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Icon, { name: "warning" }), "\xA0", " ", /* @__PURE__ */ React.createElement(
      Trans,
      {
        t,
        i18nKey: "metrics_component.fetch_error_last_metrics",
        values: { responseMessage: error.responseMessage || "", status: error.status },
        components: { em: /* @__PURE__ */ React.createElement("em", null) }
      }
    ))), /* @__PURE__ */ React.createElement(
      SearchForm,
      {
        query: filter,
        onSearch: this.onFilterChange,
        queryWidth: 300,
        placeholder: t("metrics_component.filter_placeholder")
      },
      /* @__PURE__ */ React.createElement(MetricsListContainer, null, /* @__PURE__ */ React.createElement(MetricsList, { names: filteredNames, namespace: this.props.namespace, nodeId: this.props.nodeId }))
    )));
  }
}
MetricsComponent.defaultProps = {
  filter: "",
  error: void 0
};
export default withTranslation("system")(MetricsComponent);
